import { NgClass, NgIf, NgStyle } from '@angular/common';
import { Component ,Input } from '@angular/core';
import { TFMService } from 'app/mock-api/tfm.service';
import { members } from '../../members/member-info'

@Component({
    selector: 'app-scroller_section-type01',
    standalone: true,
    imports: [NgIf, NgClass, NgStyle],
    templateUrl: './scroller_section-type01.component.html',
    styleUrl: './scroller_section-type01.component.scss',
})
export class ScrollerSectionType01Component {
    @Input() options: any = {
        showMembers: true,
        showBrands: false,
        showAffiliations: false,
    };

    public view: any = {
        members: [],
        brands: [],
        affiliations: [],
    };

    constructor(private _tfmService: TFMService) {
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-38.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-01.png?v=1',
        });
         this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-03.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-02.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-04.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-05.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-06.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-07.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-09.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-08.png?v=1',
        });
      
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-10.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-39.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-11.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-12.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-13.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-41.png?v=1',
        });
        

        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-14.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-15.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-16.png?v=1',
        });
       
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-17.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-42.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-43.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-18.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-49.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-19.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL KALTRAVEL LOGO- TRANSPARENT BG 2.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-20.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-46.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-21.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL-non-stop-logo.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-22.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-23.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-44.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-24.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-25.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-26.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-27.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-28.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-30.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-29.png?v=1',
        });
        
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-31.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-51.png?v=2',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-32.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-34.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-33.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-35.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-45.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-37.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/flight-specials.png?v=1',
        });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/gsta.png?v=1',
        });
       
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-40.png?v=1',
        });
       
      
        
       
       
        // this.view.members.push({
        //     imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-47.png?v=1',
        // });
        
        
        // this.view.members.push({
        //     imageUrl: '/assets/xltravel/members/XL MEMBER LOGOS-50.png?v=1',
        // });
        this.view.members.push({
            imageUrl: '/assets/xltravel/members/xl-masters-logo.png?v=1',
        });
        
        this.view.brands.push({ imageUrl: '/assets/images/logo/xlGo.png?v=1' });

        this.view.affiliations.push({
            imageUrl: '/assets/images/logo/xlIATA.png?v=1',
        });
    }

  ngOnInit(): void {
    //   this.loadMembers();
        this.view.logos = [];
        if (this.options.showMembers) {
            this.view.members.forEach((l) => {
                this.view.logos.push(l);
            });
        }
        if (this.options.showBrands) {
            this.view.brands.forEach((l) => {
                this.view.logos.push(l);
            });
        }
        if (this.options.showAffiliations) {
            this.view.affiliations.forEach((l) => {
                this.view.logos.push(l);
            });
        }
        // console.log(this.view);

        this._tfmService.getSite().then((res) => {
            this.view.site = res;

            this.view.site.profile = this._tfmService.getSiteProfile(
                this.view.site.profileID
            );
            this._tfmService.log(this.view);
        });
    }
    loadMembers(): void {
        const sortedMembers = [...members].sort((a, b) =>
            a.name.localeCompare(b.name)
        );
        this.view.logos = sortedMembers;
        
    }
}
